import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { Injectable, NgModule } from "@angular/core";

import { AppComponent } from "./app.component";
import { AuthenticationModule } from "./modules/authentication/authentication.module";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { HttpClientModule } from "@angular/common/http";
import { ModalModule } from "ngx-bootstrap/modal";
import { SuccessDialogComponent } from "./shared/components/success-dialog/success-dialog.component";
import { LayoutModule } from "./modules/layout/layout.module";
import { ReactiveFormsModule } from "@angular/forms";
import { LottieModule } from "ngx-lottie";
import { ToggleSidebarDirective } from "./toggle-sidebar.directive";

import { httpInterceptorProviders } from "./auth.interceptor";
import { FooterComponent } from "./modules/layout/footer/footer.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { ContactUsComponent } from "./modules/contact-us/contact-us.component";
import { ProductViewComponent } from "./modules/product-view/product-view.component";
import { TermsOfServiceComponent } from './modules/terms-of-service/terms-of-service.component';

export function lottiePlayerFactory(): any {
  return import("lottie-web/build/player/lottie_svg");
}

@Injectable({
  providedIn: "root",
})
@NgModule({
  declarations: [
    AppComponent,
    // ProfileComponent,
    // PreferencesComponent,
    SuccessDialogComponent,
    ToggleSidebarDirective,
    ContactUsComponent,
    TermsOfServiceComponent,
  ],
  imports: [
    BrowserModule,
    // RouterOutlet,
    AppRoutingModule,
    RouterModule,
    AuthenticationModule,
    SharedModule,
    HttpClientModule,
    ModalModule.forRoot(),
    BrowserAnimationsModule,

    ProductViewComponent,
    LayoutModule,
    ReactiveFormsModule,
    FooterComponent,
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule {}
